<template>
  <span class="d-book-updates-count label label-sm label-round">
    <DuiIconBroadcast />
    <span class="space-left-1em valign-middle">{{ bookUpdatesCount }}</span>
  </span>
</template>

<script>
import Vue from 'vue';

import activityFeedService from '@d-services/activity-feed-service/activity-feed-service';
import { getErrorMessage } from '@d-shared/utils/errors';

export default {
  props: {
    bookSlug: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    bookUpdatesCount: 0,
  }),
  mounted() {
    this.loadBookUpdatesCount();
  },
  methods: {
    async loadBookUpdatesCount() {
      try {
        const bookUpdatesCount = await activityFeedService.getBookActivitiesCount(this.bookSlug);
        this.$set(this, 'bookUpdatesCount', bookUpdatesCount);
      } catch (error) {
        Vue.duiNotificationManager.error(getErrorMessage(error));
      }
    },
  },
};
</script>
